export const topics = [
  {
    id: "topic-classic",
    title: "经典老片推荐",
    description: "跨越时代的光影记忆，值得反复回味的口碑佳作合集。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20moody%20collage%20of%20vintage%20film%20reels%20and%20old%20cinema%20seats%2C%20deep%20blue%20tones%2C%20nostalgic%20lighting%2C%20no%20text&width=800&height=500&seq=topic-classic&orientation=landscape",
    tags: ["剧情", "历史", "战争"],
    count: 6,
  },
  {
    id: "topic-hotseries",
    title: "当下热播剧集",
    description: "全网热度最高的连续剧，追更不迷路，一集入坑。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20grand%20ancient%20palace%20courtyard%20at%20night%20with%20warm%20lanterns%2C%20deep%20blue%20and%20gold%20tones%2C%20no%20text&width=800&height=500&seq=topic-hotseries&orientation=landscape",
    tags: ["权谋", "古装", "都市"],
    count: 4,
  },
  {
    id: "topic-highscore",
    title: "华语高分片单",
    description: "评分口碑双在线的华语佳作，闭眼入不会踩雷。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20city%20skyline%20of%20hong%20kong%20with%20neon%20reflections%2C%20deep%20blue%20and%20amber%20tones%2C%20no%20text&width=800&height=500&seq=topic-highscore&orientation=landscape",
    tags: ["剧情", "悬疑", "犯罪", "家庭"],
    count: 5,
  },
  {
    id: "topic-scifi",
    title: "科幻未来世界",
    description: "从深空到深海，一场关于人类未来的想象力盛宴。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20futuristic%20space%20station%20interior%20with%20blue%20holographic%20light%2C%20deep%20blue%20and%20cyan%20tones%2C%20no%20text&width=800&height=500&seq=topic-scifi&orientation=landscape",
    tags: ["科幻", "冒险", "青春"],
    count: 4,
  },
  {
    id: "topic-healing",
    title: "治愈系日常",
    description: "慢下来的生活美学，吃饭、旅行与那些温柔的小事。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20cozy%20kitchen%20with%20steaming%20food%20and%20warm%20lamp%20light%2C%20warm%20amber%20and%20blue%20tones%2C%20no%20text&width=800&height=500&seq=topic-healing&orientation=landscape",
    tags: ["美食", "治愈", "爱情"],
    count: 3,
  },
  {
    id: "topic-suspense",
    title: "高能悬疑烧脑",
    description: "反转不断、细节拉满，专治不服的推理爱好者。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20corridor%20with%20a%20single%20flickering%20light%20and%20long%20shadows%2C%20deep%20blue%20and%20teal%20tones%2C%20no%20text&width=800&height=500&seq=topic-suspense&orientation=landscape",
    tags: ["悬疑", "刑侦", "惊悚", "恐怖"],
    count: 5,
  },
];